import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import ArticleIconTags from '../ArticleIconTags/ArticleIconTags'
import Image from '../Image/Image'

import useWindowSize from '../../hooks/useWindowSize'
import { createGUID } from '../../utils/strings'

export default function ArticleCard (props = {
    durations: null,
    id: null,
    idPrefix: null,
    slug: null,
    tags: null,
    title: null,
    thumbnail: null,
    source: {
        slug: null,
        title: null
    }
}) {
    const {
        durations,
        id,
        slug,
        tags,
        title,
        thumbnail,
        source
    } = props

    if (!((id || slug)
            || title))
        return null

    const idPrefix = props.idPrefix
        || `article-${createGUID()}`

    const tagsId = (tags || []).length
        ? `${idPrefix}-tag`
        : ''

    const sourceId = (source || {}).slug
            && source.title
        ? `${idPrefix}-source`
        : ''

    const size = useWindowSize()

    const thumbnailRatio = useRef()

    const [thumbnailHeight, setThumbnailHeight] = useState(0)

    useEffect(() => {
        if (!thumbnailRatio.current
                || thumbnailHeight === thumbnailRatio.current.clientHeight)
            return

        setThumbnailHeight(thumbnailRatio.current.clientHeight)
    }, [size, thumbnailRatio.current])

    const thumbnailFallback = '/images/dashboard-content-thumbnail-fallback.svg'

    let thumbnailSrc = thumbnail
        && (thumbnail || '').match(/\//)
        && `${thumbnail}${
            window.location.host !== 'catapult.gse.upenn.edu'
                ? '?w=726'
                : ''}`

    if (!thumbnailSrc)
        thumbnailSrc = thumbnailFallback

    return (
        <div
            style={{
                width: '100%',
                marginBottom: 'auto'
            }}
        >
            <Link
                to={`/dashboard/hub/${slug || id}`}
                className="article-card pad-0 display-flex flex-grow flex-direction-column"
                aria-label={title}
                aria-describedby={tagsId || sourceId
                    ? `${sourceId} ${tagsId}`.trim()
                    : null}
                style={{ width: '100%' }}
            >
                <div
                    className="ratio-wide flex-none margin-b"
                    role="presentation"
                    ref={thumbnailRatio}
                    style={{ width: '100%' }}
                >
                    <div className="article-card-thumb-wrapper">
                        <Image
                            src={thumbnailSrc}
                            imgFallback={thumbnailFallback}
                            className="position-absolute article-card-thumb"
                            alt=""
                            data-object-fit="cover"
                            loading="lazy"
                            onLoad={(e) => {
                                if (e.target.src.match(/^data/))
                                    return

                                if (e.target.parentElement
                                        && e.target.parentElement.parentElement)
                                    e.target.parentElement.parentElement
                                        .setAttribute('data-loaded', true)
                            }}
                        />
                    </div>
                </div>
                <div
                    className="display-flex flex-direction-column flex-grow"
                    style={{ width: '100%' }}
                >
                    {Boolean(sourceId)
                        && (
                            <div
                                className="body-5 font-weight-normal pad-1-b"
                                style={{ opacity: 0 }}
                            >
                                <span
                                    id={sourceId}
                                    className="article-card-source-title"
                                    aria-label={`By ${source.title}.`}
                                >
                                    {source.title}
                                </span>
                            </div>)}
                    <h3 className="body-4 font-weight-bold margin-1-b">
                        <span>{title}</span>
                    </h3>
                    <ArticleIconTags
                        className="display-flex flex-align-items-center flex-nowrap body-5"
                        tags={tags}
                        durations={durations}
                    />
                </div>
            </Link>
            {Boolean(sourceId)
                && Boolean(thumbnailHeight)
                && (
                    <Link
                        to={`/dashboard/hub/search?source=${source.slug}`}
                        className="article-card-source-link text-decoration-hover"
                        style={{
                            position: 'absolute',
                            top: thumbnailHeight + 20,
                            maxWidth: '100%'
                        }}
                        aria-label={`View all from ${source.title}`}
                    >
                        <span className="body-5 article-card-source-title font-weight-normal">{source.title}</span>
                    </Link>
                )}
            {Boolean((tags || []).length
                    || Object.keys(durations || {})
                        .filter(str => durations[str])
                        .length)
                && (
                    <div className="article-card-meta-links">
                        <ArticleIconTags
                            id={tagsId}
                            className="display-flex flex-align-items-center flex-nowrap body-5"
                            tags={tags}
                            durations={durations}
                            linkTags
                        />
                    </div>)}
        </div>
    )
}
